<script lang="ts">
  import CanvasFreeDrawing from "../helpers/canvas-free-drawing";
  import { onMount } from "svelte";
  export let image: HTMLImageElement;

  export let currentColor;
  // canvas free drawing object
  export let cfd;

  let canvas: HTMLCanvasElement;

  onMount(() => {
    // for big screen fix it to 800X600
    // available width
    let width = canvas.parentElement.clientWidth;
    // fix it to 0.8 if its touch device to enable scrolling
    const isTouch = window.ontouchstart !== undefined;
    if(isTouch) {
       width = width* 0.85;
    }  
    // fit image to this width
    const ar = image.width/image.height;
    const height = width/ar;
   
    canvas.width = width;
    canvas.height = height;
    
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0,0,image.width,image.height,0,0,canvas.width,canvas.height);  

    // consider max width always
    cfd = new CanvasFreeDrawing({
      canvas,
      width: canvas.width,
      height: canvas.height,
      lineWidth: 10,
      bucketToolTolerance: 10
    });
  });
</script>

<canvas id="cfd" bind:this={canvas} />

<style type="text/scss">
  @import "Canvas";
</style>
